import { IEntity } from '@pf/shared-common';
import {
    ItemFragment,
    PurchaseOrderHeaderFragment,
    PurchaseOrderLineFragment,
    RequisitionFragment,
    RequisitionLineSearchRequestParams,
    RequisitionLineViewModelCreateBody,
    RequisitionLineViewModelRead,
    RequisitionStatus,
    ResourceAuth,
} from '@control-tower/platform-wms';
import { CustomFieldDto } from '@pf/shared/util-platform';

export type RequisitionLineRead = RequisitionLineViewModelRead & IEntity;
export type RequisitionLineCreate = RequisitionLineViewModelCreateBody;
export type RequisitionLineSearchParams = RequisitionLineSearchRequestParams;

export class RequisitionLineDto implements IEntity {
    constructor(data: Partial<RequisitionLineDto>) {
        Object.assign(this, data);
    }
    id!: string;
    lineNumber!: number;
    quantity!: number;
    status!: RequisitionStatus;
    unitOfMeasure!: string;
    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
    requestedByDate?: string;
    notes?: string | null;
    externalReferenceId?: string | null;
    resourceAuth?: ResourceAuth;
    requisition?: RequisitionFragment;
    item?: ItemFragment;
    purchaseOrder?: PurchaseOrderHeaderFragment;
    purchaseOrderLine?: PurchaseOrderLineFragment;
    customFields?: Array<CustomFieldDto> | null;
}
